import LayoutNode, { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";



export default function CreateNodeGlobalStyle(node:LayoutNode,isEditor:boolean,definitions:NodeCSSClassDefinition[]){


    let str = "";

    const realid = (isEditor) ? "#"+node.id : "#v" + node.id;
    
 
    

    for(let i = 0;i<definitions.length;i++){

        let id = (definitions[i].ignoreId)?"":realid;

        let stencils = []
        str += `${id} ${definitions[i].classTarget}{ \n`;


        for(let j = 0;j<definitions[i].attributePairs.length;j++){
                
                const att = definitions[i].attributePairs[j];
                const val = getNodeComponentAttributeValue(node,att.key,att.default??"");
                if(val!=""){
    
                    if(att.stencil){
                        stencils.push(att);
                    }
                str += `${att.cssProperty}: ${val} !important;\n`;
                }
        }

        

        str += `}\n`;


        str += `${id} .stenciled ${definitions[i].classTarget}{ \n`;
            for(let j = 0;j<stencils.length;j++){
                let s = stencils[j]
                str += `${s.cssProperty}: ${s.stencil} !important\n`;
            }

        str += `}\n`;
    }

    return str;

}



export class NodeCSSClassDefinition{
    constructor(classTarget:string,attributePairs:{key:string,cssProperty:string,default?:string,stencil?:string}[],ignoreId?:boolean){
        this.classTarget = classTarget;
        this.attributePairs = attributePairs;
        this.ignoreId = ignoreId??false;
    }

    classTarget:string;
    default?:string;
    stencil?:string;
    ignoreId?:boolean;
    attributePairs:{key:string,cssProperty:string,default?:string,stencil?:string}[];
}